"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedProxyGuestChatRequest =
/*#__PURE__*/
function (_pb_1$ProxyGuestChatR) {
  _inherits(ExtendedProxyGuestChatRequest, _pb_1$ProxyGuestChatR);

  function ExtendedProxyGuestChatRequest(properties) {
    var _this;

    _classCallCheck(this, ExtendedProxyGuestChatRequest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedProxyGuestChatRequest).call(this, properties));
    _this.type = ExtendedProxyGuestChatRequest.type;
    return _this;
  }

  _createClass(ExtendedProxyGuestChatRequest, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.property).concat(ExtendedProxyGuestChatRequest.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.ProxyGuestChatRequest.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedProxyGuestChatRequest(pb_1.ProxyGuestChatRequest.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedProxyGuestChatRequest;
}(pb_1.ProxyGuestChatRequest);

ExtendedProxyGuestChatRequest.type = "ProxyGuestChatRequest";
ExtendedProxyGuestChatRequest.context = "/guest-chat/request";
exports.ProxyGuestChatRequest = ExtendedProxyGuestChatRequest;